import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function DartsNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Darts",
    links: [
      {href: "/darts", text: "News", isIndex: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

DartsNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default DartsNav



// WEBPACK FOOTER //
// ./modules/Darts/nav/DartsNav.js